import TreeComponent from './TreeComponent';

export default TreeComponent;